import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@material-ui/core';
import {Close} from '@material-ui/icons';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {ICompetitor} from '../store/types';

interface IPropsDialog {
  open: boolean;
  competitor: ICompetitor;
  onClose: () => void;
}

const DetailCompetitorDialog: React.FC<IPropsDialog> = ({
  open,
  competitor,
  onClose,
}) => {
  const {t} = useTranslation();
  const handleOk = () => {
    onClose();
  };
  return (
    <Dialog
      aria-labelledby="simple-dialog-title"
      open={open}
      onClose={handleOk}
      className="competitor-detail-dialog"
    >
      <DialogTitle>
        <h4>{t('detalhes-competidor.informacoes-competidor')}</h4>
        <IconButton aria-label="close" onClick={handleOk}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Avatar sizes="large" alt={competitor.name} src={competitor.thumb} />
          <h3>{competitor.name}</h3>
          <p>{competitor.description}</p>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          className={`button-default btn-white`}
          type="button"
          color="primary"
          variant="contained"
          onClick={handleOk}
          startIcon={<Close />}
        >
          {t('detalhes-competidor.fechar')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DetailCompetitorDialog;



// WEBPACK FOOTER //
// ./src/features/election/components/DetailCompetitorDialog.tsx